import React, { useState, useEffect, useRef, useCallback } from "react";

import { 
  Campaign,
  CharacterItem,
} from "@dndModels";

import CommonUtilities from "@utilities/common_utilities";
import FlexBox from "@components/layout/FlexBox";
import DandDAPI from "@dndUtilities/system_api";
import ModalOrDrawer from "@components/display/ModalOrDrawer";
import LoadingBox from "@components/input/LoadingBox";
import CharacterViewInventory from "@dndComponents/character/inventory/CharacterViewInventory";
import CharConnectUtilities from "@dndUtilities/char_connect_utilities";
import DataUtilities from "@dndUtilities/data_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

const common_util = CommonUtilities.getInstance();
const api = DandDAPI.getInstance();
const connect_util = CharConnectUtilities.getInstance();
const data_util = DataUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

interface Props {
  campaign: Campaign;
}

export default function CampaignInventoryInput({ campaign }: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reloading, setReloading] = useState(false); 
  const [editing_item, setEditingItem] = useState<CharacterItem | undefined>(undefined);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const load = useCallback( async () => {
    // These make sure that the smart_hashes are populated
    await data_util.loadData({ char: campaign });
    await connect_util.connectItems(campaign);
    char_util.recalcWeights(campaign);
    setLoading(false);
  }, [campaign]);

  useEffect(() => {
    if (!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);

  const itemsChanged = useCallback(() => { 
    console.log("Char View Inventory - Items Changed");
    if (campaign.inventory) {
      api.upsertObject("campaign_inventory", campaign.inventory);
      connect_util.refreshCampaignInventory(campaign, campaign._id);
    }
  }, []);

  useEffect(() => {
    console.log("Char View Inventory");
    campaign.subscription_holder.subscribe("Items", mounted, itemsChanged);
  }, [campaign, itemsChanged]);
    
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer 
          open={editing_item !== undefined}
          onClose={() => setEditingItem(undefined) }>
          { renderEditingItem() }
        </ModalOrDrawer>
      </>
    );
  }

  const renderEditingItem = () => {
    if (editing_item) {
      if (editing_item._id === "") {
        return (
          <FlexBox direction="column">
            <FlexBox xs_expand={0} className="header centered">Select an Item to Add</FlexBox>

          </FlexBox>
        );
      } else {
        // Essentially the same as in Char Inventory, but with no controls for Equip or Attune.
      }
    }
    return <></>
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else if (campaign.inventory) {
    return (
      <CharacterViewInventory
        char={campaign}
        inventory={campaign.inventory}
        shared={false}
        disabled={false}
      />
    );
  }
  return <></>
  // return (
  //   <FlexBox direction="column">
  //     <FlexBox direction="row">
  //       <FlexBox xs_expand={0} className="padded">
  //         <AddButton
  //           fab
  //           disabled={processing}
  //           onClick={() => {
  //             // if (campaign.inventory) {
  //             //   const char_item = new CharacterItem();
  //             //   campaign.inventory.items.push(char_item);
  //             //   setEditingItem(char_item);
  //             // }
  //             // Same as Manage Inventory
  //           }}
  //         />
  //       </FlexBox>
  //       <FlexBox xs_expand={0} className="padded">
  //         <RefreshButton
  //           disabled={processing}
  //           onClick={ async () => {
  //             setProcessing(true);
  //             await api.loadCampaignInventory({ campaign });
  //             setProcessing(false);
  //           }}
  //         />
  //       </FlexBox>
  //     </FlexBox>
  //     <Grid container spacing={0} direction="row">
  //       { campaign.inventory && campaign.inventory.items.map(player => {
  //         return (
  //           <Grid size={{ xs:12, sm: 6, md: 4, lg: 3 }} key={player._id}>
  //             <CampaignInventoryItemInput
  //               campaign={campaign}
  //               char_item={player}
  //               onUpdated={() => { setReloading(true); }}
  //             />
  //           </Grid>
  //         );
  //       })}
  //     </Grid>
  //     { renderExtras() }
  //   </FlexBox>
  // );
}
